import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
interface Plan {
  id: string;
  emoji: string;
  name: string;
  meta: string;
  price: string;
  href: string;
  cta: string;
  badge?: string;
  includes: string[];
}
const PLANS: Plan[] = [{
  id: 'basico',
  emoji: '📘',
  name: 'SISTEMA INTEGRAL',
  meta: '6 módulos + 540 fichas + 8 bonos',
  price: '$19.990',
  href: 'https://intervencion-del-habla.impultienda.ar/checkout',
  cta: 'SÍ, QUIERO EL SISTEMA INTEGRAL →',
  includes: ['6 módulos clínicos completos', '540 fichas clínicas listas para usar', '3 rangos etarios cubiertos', '8 bonos profesionales incluidos', 'Acceso inmediato · Descarga en PDF', 'Acceso de por vida']
}, {
  id: 'pro',
  emoji: '🏆',
  name: 'SISTEMA + PACK PRO',
  meta: 'Todo lo anterior + GPS Clínico + Bóveda Élite',
  price: '$28.990',
  href: 'https://intervencioncheck.librosdigitales.pro/cart/46903485333643:1',
  cta: 'SÍ, QUIERO EL PACK PRO →',
  badge: '⭐ POPULAR',
  includes: ['Todo lo del Sistema Integral', '🧠 GPS Clínico — una guía paso a paso que te dice qué técnica usar según lo que llega ese día al consultorio', 'Qué hacer cuando el paciente entra en crisis y cómo manejar a los padres más complicados sin perder la calma', 'Cómo saber con seguridad cuándo el paciente está listo para terminar el tratamiento (criterios de alta)', '🏆 Bóveda Élite — 5 modelos de informes clínicos editables en Word, listos para completar y entregar (te ahorra los domingos)', '12 mensajes para padres listos para mandar por WhatsApp entre sesión y sesión', 'Una hoja resumen para entregarle al docente con todo lo que necesita saber del paciente', 'Una calculadora simple para armar paquetes de tratamiento y cobrar lo que realmente vale tu trabajo']
}, {
  id: 'max',
  emoji: '🚀',
  name: 'PACK FARFULLEO (CLUTTERING)',
  meta: 'Todo lo anterior + Protocolo 100 Farfulleo (Cluttering)',
  price: '$34.990',
  href: 'https://intervencioncheck.librosdigitales.pro/cart/47025786486923:1',
  cta: 'SÍ, QUIERO EL PACK FARFULLEO →',
  badge: '🔥 MÁS COMPLETO',
  includes: ['Todo lo del Sistema + Pack Pro', '🎯 Protocolo 100: Intervención en Farfulleo (Cluttering)™', 'Muchos pacientes que llegan por tartamudez en realidad farfullan. Si no diferenciás el tratamiento no funciona.', '100 ejercicios correlativos listos para usar desde la primera sesión', 'Instrucciones para el profesional + consigna para el paciente en cada ficha', 'Registro clínico incluido en cada ejercicio', 'Sin materiales externos. Sin preparación previa. Imprimís y empezás.']
}];
export function Pricing() {
  const [selectedId, setSelectedId] = useState<string>('max');
  const selected = PLANS.find(p => p.id === selectedId) || PLANS[0];
  return <section id="compra" className="flex flex-col gap-6 py-16 scroll-mt-8" data-id="element-95">
      <h3 className="font-serif text-4xl font-bold text-[#0F4C3A] text-center" data-id="element-96">
        Elegí tu plan
      </h3>

      <p className="text-center text-stone-600" data-id="element-97">
        Todas las opciones incluyen el Sistema Integral completo y la garantía
        de 7 días.
      </p>

      <div className="flex flex-col bg-[#0F4C3A] text-white p-5 md:p-8 rounded-3xl shadow-2xl border-4 border-[#1B5E4F] gap-4" data-id="element-98">
        {/* Plan selector rows */}
        <div className="flex flex-col gap-3" data-id="element-99">
          {PLANS.map(plan => {
          const isSelected = selectedId === plan.id;
          return <button key={plan.id} onClick={() => setSelectedId(plan.id)} className={`flex flex-col text-left rounded-2xl p-4 md:p-5 transition-all relative border-2 ${isSelected ? 'bg-white/15 border-[#D97757] shadow-lg' : 'bg-white/5 border-white/10 hover:bg-white/10'}`} data-id="element-100">
                {plan.badge && <span className="absolute -top-3 right-3 bg-[#D97757] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-md whitespace-nowrap" data-id="element-101">
                    {plan.badge}
                  </span>}

                <div className="flex flex-row items-start gap-3 w-full" data-id="element-102">
                  {/* Radio circle */}
                  <div className={`flex-shrink-0 mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${isSelected ? 'border-[#D97757] bg-[#D97757]' : 'border-white/40'}`} data-id="element-103">
                    {isSelected && <div className="w-2 h-2 rounded-full bg-white" data-id="element-104" />}
                  </div>

                  {/* Content */}
                  <div className="flex flex-col gap-1 flex-1 min-w-0" data-id="element-105">
                    <div className="flex flex-row items-center gap-2" data-id="element-106">
                      <span className="text-xl" data-id="element-107">{plan.emoji}</span>
                      <p className="font-bold text-white text-base md:text-lg" data-id="element-108">
                        {plan.name}
                      </p>
                    </div>
                    <p className="text-sm text-white/70 leading-snug" data-id="element-109">
                      {plan.meta}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="flex flex-col items-end flex-shrink-0" data-id="element-110">
                    <p className={`font-serif font-bold text-xl md:text-2xl ${isSelected ? 'text-[#D97757]' : 'text-white'}`} data-id="element-111">
                      {plan.price}
                    </p>
                    <p className="text-[10px] text-white/60 uppercase tracking-wider" data-id="element-112">
                      ARS
                    </p>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single CTA */}
        <div className="flex flex-col gap-3 mt-2" data-id="element-113">
          <AnimatePresence mode="wait" data-id="element-114">
            <motion.a key={selected.id} href={selected.href} onClick={() => trackInitiateCheckout()} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18
          }} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="flex flex-col items-center justify-center w-full bg-[#D97757] hover:bg-[#c26547] text-white font-bold text-base md:text-xl py-5 md:py-6 px-4 rounded-xl shadow-xl transition-colors text-center" data-id="element-115">
              {selected.cta}
            </motion.a>
          </AnimatePresence>

          <img src="https://cdn.magicpatterns.com/uploads/cVXWqaJjdh9gCnJcqWN39J/imagen.png" alt="Pago seguro con Mercado Pago — Aceptamos Visa, Mastercard, American Express, Diners Club" className="w-full h-[60px] md:h-[76px] object-contain bg-white rounded-xl" data-id="element-116" />

          <p className="text-xs md:text-sm text-[#FBF8F3]/70 flex flex-col items-center gap-1 mt-1" data-id="element-117">
            <span data-id="element-118">🔒 Pago seguro · Garantía de 7 días</span>
          </p>
        </div>

        {/* What's included */}
        <div className="flex flex-col gap-3 bg-white/5 border border-white/10 rounded-2xl p-5 mt-2" data-id="element-119">
          <p className="text-xs font-bold uppercase tracking-widest text-[#D97757]" data-id="element-120">
            {selected.name} incluye:
          </p>
          <AnimatePresence mode="wait" data-id="element-121">
            <motion.div key={selected.id} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18
          }} className="flex flex-col gap-2" data-id="element-122">
              {selected.includes.map((item, idx) => <div key={idx} className="flex flex-row items-start gap-2" data-id="element-123">
                  <Check className="text-[#D97757] w-4 h-4 flex-shrink-0 mt-1" data-id="element-124" />
                  <p className="text-sm text-white/90 leading-snug" data-id="element-125">{item}</p>
                </div>)}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}